import { useEffect, useState, useRef, useCallback } from "react";
import StatsCards from "../StatCard";
import LeftSideComponent from "./LeftSideComponent";
import RightSideComponent from "./RightSideComponent";
import {
  getDashboardMetrics,
  getRecentInterviews,
} from "../../application/services/getDashboardMetrics";
import "./Style.css";
import { useDispatch } from "react-redux";

const DashboardTab = ({ activeMenu, setActivePage }) => {
  const dispatch = useDispatch();
  const [metricsData, setMetricsData] = useState({});
  const [recentInterviews, setRecentInterviews] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const hasFetched = useRef(false);
  const limit = 5;

  const fetchRecentInterviews = useCallback(
    async (page, append = false) => {
      setIsLoading(true);
      try {
        const result = await getRecentInterviews(page, limit);

        const interviews = result?.data || [];

        if (append) {
          setRecentInterviews((prev) => [...prev, ...interviews]);
        } else {
          setRecentInterviews(interviews);
        }
        setHasMore(result?.pagination?.hasNext || false);
      } catch (error) {
        console.error("Error fetching recent interviews:", error);
        setHasMore(false);
      } finally {
        setIsLoading(false);
      }
    },
    [limit]
  );

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;

    const fetchDashboardData = async () => {
      const [metricsResult, recentInterviewsResult] = await Promise.allSettled([
        getDashboardMetrics(),
        getRecentInterviews(1, limit),
      ]);

      if (metricsResult.status === "fulfilled") {
        try {
          setMetricsData(metricsResult.value?.data || {});
        } catch (error) {
          console.error("Error processing metrics:", error);
        }
      } else {
        console.error("Error fetching metrics:", metricsResult.reason);
      }

      if (recentInterviewsResult.status === "fulfilled") {
        try {
          const result = recentInterviewsResult.value;
          const interviews = result?.data || [];
          setRecentInterviews(interviews);
          setHasMore(result?.pagination?.hasNext || false);
        } catch (error) {
          console.error("Error processing recent interviews:", error);
        }
      } else {
        console.error(
          "Error fetching recent interviews:",
          recentInterviewsResult.reason
        );
      }
    };

    fetchDashboardData();
  }, [dispatch, limit]);

  const loadMoreInterviews = useCallback(() => {
    if (isLoading || !hasMore) return;

    const nextPage = currentPage + 1;
    setCurrentPage(nextPage);
    fetchRecentInterviews(nextPage, true);
  }, [currentPage, isLoading, hasMore, fetchRecentInterviews]);

  const metricsArray = Object.entries(metricsData);
  return (
    <>
      <StatsCards metricsArray={metricsArray} />
      <div className="dashboard-components-grid">
        <LeftSideComponent setActivePage={setActivePage} />
        <RightSideComponent
          activeMenu={activeMenu}
          recentInterviews={recentInterviews}
          isLoading={isLoading}
          hasMore={hasMore}
          onLoadMore={loadMoreInterviews}
        />
      </div>
    </>
  );
};

export default DashboardTab;
